import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { gql } from "@apollo/client";
import {
  GraphQLClient,
  GraphQLErrorMessage,
} from "../../../../../shared/gql-client";
import { SettingsMutateSliceModel } from "./SettingsMutateSliceModel";
import { settingsFormModel } from "../../domain/models/settingsFormModel";
import { toast } from "sonner";
import i18next from "i18next";
import moment from "moment";

export const getSettings = createAsyncThunk(
  "planning/settings/get",
  async (_, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      const response = await client.query<undefined, string[]>(
        "getHolidays",
        gql(`
          query getHolidays {
            getHolidays
          }
          `),
      );

      const holidays = response
        .map((item) => {
          const date = moment(item);
          return date.format("DD-MM-YYYY");
        })
        .join("\n");

      return { holidays: holidays };
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updateSettings = createAsyncThunk(
  "planning/settings/update",
  async (settings: settingsFormModel, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    const holidays =
      settings?.holidays?.split("\n").map((item) => {
        const date = moment(item, "DD-MM-YYYY");
        return date.format("YYYY-MM-DD");
      }) ?? [];

    try {
      const response: string[] = await client.mutate(
        "setHolidays",
        gql(`
                mutation setHolidays($value: [Date!]!) {
                    setHolidays(
                        value: $value
                    )
                }
              `),
        { value: holidays },
      );

      const savedHolidays = response
        .map((item) => {
          const date = moment(item);
          return date.format("DD-MM-YYYY");
        })
        .join("\n");

      return { holidays: savedHolidays };
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  loading: true,
  settings: undefined,
} as SettingsMutateSliceModel;

const SettingsMutateSlice = createSlice({
  name: "settingsMutate",
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.settings = action.payload;
    });
    builder.addCase(updateSettings.fulfilled, (state, action) => {
      state.settings = action.payload;
      toast.success(i18next?.t("common:planning.settings.updated"));
    });

    builder.addMatcher(
      (action) =>
        [getSettings.rejected.type, updateSettings.rejected.type].includes(
          action.type,
        ),
      (state, action: { payload: GraphQLErrorMessage }) => {
        state.loading = false;
        console.error(action.payload);
        toast.error(action.payload.message);
      },
    );
  },
});

export const { clear, setLoading } = SettingsMutateSlice.actions;

export default SettingsMutateSlice.reducer;
